// CSS Modules - component class name prefix: ElasticSearch__

<template>
  <div :class="$style.container">
    <Search
      v-if="initialized"
      :searchPlaceholder="config.placeholder"
      :selectedSuggestion="selectedSuggestion"
      :model="model"
      :showDidYouMean="didYouMeanVisible"
      :searchSynonymSuggest="searchSynonymSuggest"
      :searchSynonym="searchSynonym"
      @submitted="submitSearch"
      @active="getSearchResults"
      @inactive="handleInactive"
      @keyUpUp="handleKeyUp"
      @keyUpDown="handleKeyDown"
      @keyUpEnter="submitSearch"
      @change="handleSearchInputChange"
      @initialize="handleSearchInputInitialize"
    />
    <ul
      v-if="suggestions.length !== 0"
      v-show="active"
      :class="$style.suggestions"
    >
      <li
        v-for="(suggestion, index) in suggestions"
        :class="[
          $style.suggestion,
          { [$style.hover]: index === selectedSuggestionIndex }
        ]"
        :key="index"
        @click="() => handleSuggestionClick(suggestion.text)"
      >
        <span v-html="suggestion.text"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";
import Search from "../Search/Search";
import getSearchSynonyms from "../../xhr/search/getSearchSynonyms";

export default {
  name: "ElasticSearch",
  components: {
    Search
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    model: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      searchSynonymSuggest: [],
      suggestions: [],
      selectedSuggestion: "",
      active: false,
      searchContainer: window.searchContainer,
      disableExternalDocuments: window.disableExternalDocuments,
      selectedSuggestionIndex: -1,
      searchSynonym: null,
      searchSynonyms: null,
      initialized: false
    };
  },
  computed: {
    didYouMeanVisible() {
      return !this.active || this.suggestions.length === 0;
    }
  },
  methods: {
    handleSearchInputInitialize(term, preventSuggestions) {
      this.handleSearchInputChange(term);
      if (!this.searchSynonym) {
        this.getSearchResults(term, preventSuggestions);
      }
    },
    handleSearchInputChange(term) {
      this.searchSynonym = null;

      if (term.length > 0) {
        this.checkSearchSynonym(term);
      }
    },
    findSearchSynonym(synonyms, term) {
      const termLowerCase = term.toLowerCase();

      for (const key in synonyms) {
        for (const workKey in synonyms[key]) {
          const word = synonyms[key][workKey];
          if (word.toLowerCase() === termLowerCase) {
            return key;
          }
        }
      }
    },
    checkSearchSynonym(term) {
      const terms = term || this.terms.join(" ");
      this.searchSynonym = this.findSearchSynonym(this.searchSynonyms, terms);
    },
    resetSearchSynonymSuggest() {
      this.searchSynonymSuggest = [];
    },
    handleInactive() {
      this.emptySuggestions();
    },
    submitSearch(terms) {
      this.resetSearchSynonymSuggest();

      if (this.config.headerSearch) {
        const queryTerms = terms.toString().replace(/,/g, "+");
        const submitUrl =
          this.config.submitUrl +
          (queryTerms ? `?wika-search=${queryTerms}` : "");
        window.location = submitUrl;
      } else if (terms[0] !== "") {
        this.active = false;
        this.$emit("submitted", terms);
      }
    },
    getSearchResults(terms, preventSuggestions) {
      if (!terms.length || (terms.length === 1 && terms[0].length < 2)) {
        this.emptySuggestions();
      } else {
        axios({
          url: window.suggestSearchUrl,
          method: "post",
          data: {
            word: terms,
            language: window.currentLanguage,
            country:
              window.currentCountry.toLowerCase() === "gb"
                ? "en"
                : window.currentCountry, // TODO: think of better solution/ technical concept for this quick fix
            container: this.searchContainer,
            disableExternalDocuments: this.disableExternalDocuments
          }
        })
          .then(response =>
            this.processSearch(response.data, preventSuggestions)
          )
          .catch(error => console.error(error));
      }
    },
    emptySuggestions() {
      this.active = false;
      this.suggestions = [];
      this.resetSearchSynonymSuggest();
    },
    processSynonyms(data) {
      if (
        this.suggestions.length === 0 &&
        data.suggest &&
        data.suggest["content-term-suggestion"]
      ) {
        const searchSynonymSuggest = data.suggest["content-term-suggestion"]
          .map(word => {
            if (word.options.length > 0) {
              return word.options.sort((a, b) => b.score - a.score)[0].text;
            }
          })
          .filter(word => word);

        this.searchSynonymSuggest = searchSynonymSuggest;
      } else {
        this.resetSearchSynonymSuggest();
      }
    },
    processSearch(data, preventSuggestions) {
      if (!preventSuggestions) {
        this.active = true;
        this.suggestions = data.suggest["prefix-suggest"][0].options;
        this.selectedSuggestionIndex = -1;
      }
      this.processSynonyms(data);
    },
    handleSuggestionClick(suggestion) {
      this.selectedSuggestion = suggestion;
      this.active = false;
      this.submitSearch([suggestion]);
    },
    handleKeyUp() {
      if (this.selectedSuggestionIndex > 0) {
        this.selectedSuggestionIndex--;
        this.selectedSuggestion = this.suggestions[
          this.selectedSuggestionIndex
        ].text;
      }
    },
    handleKeyDown() {
      if (this.selectedSuggestionIndex < this.suggestions.length - 1) {
        this.selectedSuggestionIndex++;
        this.selectedSuggestion = this.suggestions[
          this.selectedSuggestionIndex
        ].text;
      }
    }
  },
  mounted() {
    getSearchSynonyms(window.searchSynonymUrl).then(synonyms => {
      this.searchSynonyms = synonyms;
      this.initialized = true;
    });
  }
};
</script>

<style module lang="scss">
@import "./ElasticSearch.scss";
</style>
